'use strict';

import React, {useState, useEffect} from 'react';
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  ImageBackground,
  Image,
} from 'react-native';

import FastImage from '../FastImage';
import {
  getLabelForType,
  getLightIconForType,
  getGreyIconForType,
  formatDate,
} from '../../utils/trustContent';

const IconBar = ({type, date, statusComponent, displayType}) => {
  const iconSource = getGreyIconForType(type);
  const typeLabel = getLabelForType(displayType);
  return (
    <View style={iconBarStyles.iconBar}>
      <Image style={iconBarStyles.icon} source={iconSource} />
      <Text style={iconBarStyles.text}> {typeLabel} • </Text>
      <Text style={iconBarStyles.text}>{formatDate(date)}</Text>
      {statusComponent}
    </View>
  );
};

const TrustFeaturedCard = ({
  id,
  getImage,
  onPress,
  title,
  subtitle,
  type,
  date,
  statusComponent,
  displayType,
}) => {
  const [imageURL, setImageURL] = useState('');

  useEffect(() => {
    const fetchImageURL = async () => {
      const image = await getImage();
      if (!image) {
        return;
      }
      setImageURL(image);
    };

    fetchImageURL();
  }, [getImage]);

  const backupUpImage = getLightIconForType(type);

  const imageLayout =
    imageURL && type === 'Videos' ? (
      <ImageBackground
        style={[
          styles.image,
          {
            justifyContent: 'center',
            alignItems: 'center',
          },
        ]}
        resizeMode="cover"
        source={{uri: imageURL}}>
        <View style={styles.playButtonContainer}>
          <Image
            style={styles.playButtonIcon}
            source={require('../../assets/Button_Play_White.png')}
          />
        </View>
      </ImageBackground>
    ) : imageURL ? (
      <FastImage
        style={styles.image}
        resizeMode="cover"
        source={{uri: imageURL}}
      />
    ) : backupUpImage ? (
      <View style={styles.trustLogoImage}>
        <FastImage
          style={styles.trustLogo}
          resizeMode="cover"
          source={backupUpImage}
        />
      </View>
    ) : (
      <FastImage
        style={styles.placeholderImage}
        resizeMode="contain"
        source={require('../../assets/Image_Loading_Placeholder.png')}
      />
    );

  return (
    <TouchableOpacity
      key={id}
      activeOpacity={0.7}
      style={[{height: 294, width: 304, flex: 1}]}
      onPress={onPress}>
      <View style={styles.container}>
        {imageLayout}
        <View style={styles.contentWrapper}>
          <IconBar
            displayType={displayType}
            type={type}
            date={date}
            statusComponent={statusComponent}
          />
          <Text style={styles.title} numberOfLines={1}>
            {title}
          </Text>
          <Text style={styles.subtitle} numberOfLines={2}>
            {subtitle}
          </Text>
        </View>
      </View>
    </TouchableOpacity>
  );
};

const iconBarStyles = StyleSheet.create({
  iconBar: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingBottom: 8,
  },
  icon: {
    height: 13,
    width: 16,
  },
  text: {
    fontWeight: '600',
    fontSize: 12,
    lineHeight: 14.52,
    letterSpacing: 0,
    color: '#798B93',
  },
});

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'flex-start',
    backgroundColor: '#F8F8F8',
    borderRadius: 4,
    overflow: 'hidden',
  },
  image: {
    height: 180,
  },
  trustLogoImage: {
    width: '100%',
    height: 180,
    backgroundColor: '#00736D',
    justifyContent: 'center',
    alignItems: 'center',
  },
  trustLogo: {
    width: 80,
    height: 80,
  },
  placeholderImage: {
    width: '100%',
    height: 180,
    backgroundColor: '#EFF4F6',
  },
  contentWrapper: {
    flex: 1,
    padding: 12,
    paddingBottom: 30,
  },
  icon: {
    marginRight: 6,
    width: 24,
    height: 24,
  },
  title: {
    marginBottom: 8,
    fontSize: 15,
    fontWeight: '700',
    color: '#343A40',
    lineHeight: 18,
  },
  subtitle: {
    fontSize: 13,
    fontWeight: '400',
    color: '#7E7E7E',
    lineHeight: 15,
    minHeight: 32,
  },
  playButtonContainer: {
    backgroundColor: 'rgba(0,0,0,0.5)',
    borderRadius: 8,
    width: 100,
    height: 60,
    justifyContent: 'center',
    alignItems: 'center',
  },
  playButtonIcon: {
    width: 31,
    height: 40,
  },
});

export default TrustFeaturedCard;
